import clsx from 'clsx';
import React from 'react';
import { Icon } from '../../Icon/Icon';
import styles from './Step.module.scss';

export interface Step {
	title: string;
	subTitle: string;
	subTitleClassName?: string;
	state: 'DONE' | 'IN_PROGRESS' | 'UNSET';
	component: (prop?: any) => JSX.Element;
}

interface StepProps extends Step {
	isActive: boolean;
	neutral?: boolean;
	// Stack the subtitle beneath the title instead of inline beside it.
	stacked?: boolean;
	// Numbered variant (Stigg look): number-in-circle instead of the outlined dot treatment.
	numbered?: boolean;
	// 1-based position, shown inside the circle in the numbered variant.
	stepNumber?: number;
	onPress(): void;
}

export const Step = ({ title, subTitle, neutral, subTitleClassName, stacked, numbered, stepNumber, onPress, state, isActive }: StepProps) => {
	const showInnerCircle = state === 'IN_PROGRESS';
	const renderCircleContent = () => {
		if (state === 'DONE') {
			return <Icon imgType='v_icon' className={styles.doneImg} color={numbered ? 'success900' : 'white'} />;
		}
		if (numbered) {
			return <span className={styles.stepNumber}>{stepNumber}</span>;
		}
		return showInnerCircle ? <div className={styles.innerCircle}></div> : null;
	};
	return (
		<div onClick={onPress} className={styles.stepContainer}>
			<div
				className={clsx(
					styles.mainCircle,
					numbered ? styles[`${state}numbered`] : styles[`${state}circle`],
					numbered && styles.numberedCircle,
					!numbered && neutral && styles[`${state}circleNeutral`],
					!numbered && isActive && (neutral ? styles.activeNeutralButton : styles.activeButton),
				)}
				data-testid='step-circle'
			>
				{renderCircleContent()}
			</div>
			<div className={clsx(styles.textContainer, stacked && styles.textContainerStacked)}>
				<span className={clsx(styles.stepText, neutral && styles.neutralTitle)}>{title}</span>
				<span className={clsx(styles.stepText, styles.stepSubtitle, neutral && styles.neutralSubTitle, subTitleClassName)}>{subTitle}</span>
			</div>
		</div>
	);
};
